// Professional.patientSatisfactionActions is a Prisma Json column (a Json column
// cannot carry a Prisma enum), so the shape lives here and is shared between
// the API and the apps.

export const PATIENT_SATISFACTION_ACTION_TYPES = [
  'INTERNAL_FORM',
  'GOOGLE_REVIEW',
] as const;

export type PatientSatisfactionActionType =
  (typeof PATIENT_SATISFACTION_ACTION_TYPES)[number];

export const PATIENT_SATISFACTION_STARS = ['1', '2', '3', '4', '5'] as const;

export type PatientSatisfactionStar =
  (typeof PATIENT_SATISFACTION_STARS)[number];

export const PATIENT_SATISFACTION_RESPONSES_PAGE_SIZE = 15;

export type PatientSatisfactionActions = Record<
  PatientSatisfactionStar,
  PatientSatisfactionActionType | null
>;

// Tolerant parser for the raw Json column value. A typo in Forest costs one
// missing CTA, never a broken patient page.
export const parsePatientSatisfactionActions = (
  value: unknown,
): PatientSatisfactionActions => {
  const actions: PatientSatisfactionActions = {
    '1': null,
    '2': null,
    '3': null,
    '4': null,
    '5': null,
  };
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return actions;
  }
  for (const star of PATIENT_SATISFACTION_STARS) {
    const raw = (value as Record<string, unknown>)[star];
    if (
      (PATIENT_SATISFACTION_ACTION_TYPES as readonly unknown[]).includes(raw)
    ) {
      actions[star] = raw as PatientSatisfactionActionType;
    }
  }
  return actions;
};
